var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value && _vm.type)?_c('div',[_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.value,"type":_vm.type}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }